import Page from '@/components/Page';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Members from './components/Members';
import { useExpand } from '@vkruglikov/react-telegram-web-app';
import { useParams } from 'react-router-dom';
import { useErrorBoundary } from 'react-error-boundary';
import AnimationShield from '@/icons/animations/Shield.json'
import Lottie from 'lottie-react';
import { animationSizes } from '../../../../constants';
import { HandySvg } from 'handy-svg';
import IconUnmember from "@/icons/settings/unmember.svg";
import IconCaptcha from "@/icons/settings/captcha.svg";
import IconWeb from "@/icons/settings/web.svg";
import IconSettings from "@/icons/settings/settings-filled.svg";
import Countries from './components/Countries';
import Level from './components/Level';
import Captcha from './components/Captcha';
import Load from '@/components/Load'
import SettingsApi from '@/features/Settings/api'
import useEnvInitData from '@/hooks/useEnvInitData'

export default function ShieldPage() {
	const { raffle_id } = useParams();
	const { t } = useTranslation()
	const [tab, setTab] = useState(false)
	const [isExpanded, expand] = useExpand();
	const { showBoundary } = useErrorBoundary();
	const [data, setData] = useState({})
	const [loading, setLoading] = useState(true)
	const [InitDataUnsafe, InitData] = useEnvInitData();

	useEffect(() => {
		expand()
		if (!raffle_id) showBoundary();

		SettingsApi.shield({
			initData: InitData,
			raffle: raffle_id
		}).then(function(result) {
			setData(result)
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setLoading(false)
		})
	}, [InitData, raffle_id])

	return (
		<Page title={t('features.settings.shield.title')}>
			{loading ?
				<Load/>
			: tab === false ?
				<div className='ShieldPage'>
					<div className='boxIntro'>
						<div className='boxIntro_sticker'>
							<Lottie animationData={AnimationShield} loop={false} style={animationSizes['AnimationShield']} />
						</div>
						<div className='boxIntro_title'>{t('features.settings.shield.title')}</div>
						<div className='boxIntro_text'>
							<Trans i18nKey="features.settings.shield.text" components={{ br: <br /> }} />
						</div>
					</div>

					<div className='boxTitle'>{t('features.settings.shield.title')}</div>
					<div className='boxFolder'>
						<button className='boxFolderItem' onClick={() => {setTab('level')}}>
							<div className='boxFolderItem-icon' style={{background: '#FF3A22'}}>
								<HandySvg src={IconCaptcha} />
							</div>
							<div className='boxFolderItem-info'>
								<div className='boxFolderItem-name'>{t('features.settings.shield.level.title')}</div>
							</div>
						</button>
						<button className='boxFolderItem' onClick={() => {setTab('members')}}>
							<div className='boxFolderItem-icon' style={{background: '#38C557'}}>
								<HandySvg src={IconUnmember} />
							</div>
							<div className='boxFolderItem-info'>
								<div className='boxFolderItem-name'>{t('features.settings.shield.members.title')}</div>
							</div>
						</button>
						<button className='boxFolderItem' onClick={() => {setTab('countries')}}>
							<div className='boxFolderItem-icon' style={{background: '#FF9400'}}>
								<HandySvg src={IconWeb} />
							</div>
							<div className='boxFolderItem-info'>
								<div className='boxFolderItem-name'>{t('features.settings.countries.title')}</div>
							</div>
						</button>
						<button className='boxFolderItem' onClick={() => {setTab('captcha')}}>
							<div className='boxFolderItem-icon' style={{background: '#2DAAE9'}}>
								<HandySvg src={IconSettings} />
							</div>
							<div className='boxFolderItem-info'>
								<div className='boxFolderItem-name'>{t('features.settings.shield.captcha.title')}</div>
							</div>
						</button>
					</div>
				</div>
			: tab === 'countries' ?
				<Countries data={data} setData={setData} back={() => setTab(false)} />
			: tab === 'members' ?
				<Members back={() => setTab(false)} />
			: tab === 'level' ?
				<Level data={data} setData={setData} back={() => setTab(false)} members={() => setTab('members')} />
			: tab === 'captcha' ?
				<Captcha data={data} setData={setData} back={() => setTab(false)} />
			: null}
		</Page>
	)
}
